function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Accordion, AccordionDetails, AccordionSummary, Button, Typography } from "@material-ui/core";
import { ExpandMoreRounded, ExpandMoreSharp } from "@material-ui/icons";
import { Component } from "react";
var GuideSideMenu = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(GuideSideMenu, Component);
    var _super = _create_super(GuideSideMenu);
    function GuideSideMenu() {
        _class_call_check(this, GuideSideMenu);
        return _super.apply(this, arguments);
    }
    _create_class(GuideSideMenu, [
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, prismicData = _this_props.prismicData, activeRoute = _this_props.activeRoute, history = _this_props.history, isModal = _this_props.isModal, setSectionData = _this_props.setSectionData, isDrawer = _this_props.isDrawer, closeMenu = _this_props.closeMenu, setSubroute = _this_props.setSubroute;
                if (!prismicData) return;
                return /*#__PURE__*/ _jsx("div", {
                    className: "side-menu".concat(closeMenu ? "-mobile" : ""),
                    children: prismicData.body.map(function(data) {
                        return /*#__PURE__*/ _jsxs(Accordion, {
                            defaultExpanded: true,
                            className: "sidebar-acc",
                            children: [
                                /*#__PURE__*/ _jsx(AccordionSummary, {
                                    className: "sidebar-summary",
                                    expandIcon: /*#__PURE__*/ _jsx(ExpandMoreSharp, {}),
                                    style: {
                                        justifyContent: "end"
                                    },
                                    children: /*#__PURE__*/ _jsxs(Typography, {
                                        className: "sidebar-title",
                                        style: {
                                            fontSize: 16
                                        },
                                        children: [
                                            data.primary.category_title,
                                            " "
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(AccordionDetails, {
                                    style: {
                                        display: "flex",
                                        flexDirection: "column"
                                    },
                                    children: data.items.map(function(item) {
                                        var isActive = item.section_url === activeRoute;
                                        return /*#__PURE__*/ _jsx(Button, {
                                            className: "sidebar-section-button",
                                            onClick: function() {
                                                if (closeMenu) closeMenu();
                                                if (isModal) {
                                                    setSectionData(item);
                                                    setSubroute(item.section_url);
                                                    var routerContainer = document.querySelector(".section-content-wrapper");
                                                    if (routerContainer) {
                                                        routerContainer.scrollTo(0, 0);
                                                    }
                                                } else {
                                                    history.push("/guide/".concat(item.section_url), {
                                                        sectionData: item
                                                    });
                                                    var routerContainer1 = document.querySelector(".router-container");
                                                    if (routerContainer1) {
                                                        routerContainer1.scrollTo(0, -1000);
                                                    }
                                                }
                                            },
                                            children: /*#__PURE__*/ _jsxs("div", {
                                                className: "section-text".concat(isActive ? "-active" : ""),
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "section-title",
                                                        children: item.section_title
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "section-subtitle",
                                                        children: item.section_subtitle
                                                    })
                                                ]
                                            })
                                        }, item.section_title);
                                    })
                                })
                            ]
                        }, data.primary.category_title);
                    })
                });
            }
        }
    ]);
    return GuideSideMenu;
}(Component);
export default GuideSideMenu;
